import { render, staticRenderFns } from "./BuildSpacerBlock.vue?vue&type=template&id=3eceeaae&scoped=true&"
import script from "./BuildSpacerBlock.vue?vue&type=script&lang=js&"
export * from "./BuildSpacerBlock.vue?vue&type=script&lang=js&"
import style0 from "./BuildSpacerBlock.vue?vue&type=style&index=0&id=3eceeaae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eceeaae",
  null
  
)

export default component.exports